$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".hk-drawer-menu-inner a.hk-parent-link", function (e) {
  e.preventDefault();
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').removeClass('active');
    jQuery('.hk-drawer-menu-inner a.hk-parent-link').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-element-sub-option').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});










$(document).on("click", ".hk-cart-button", function (e) {
document.querySelector('cart-drawer')?.open();
});










$(document).on("click", "a.hk-search-icon", function (e) {
  e.preventDefault();
 $('.hk-header details-modal.header__search summary.header__icon').trigger('click');
});

/* ---------------- Header cart count ---------------- */

function hkUpdateCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.hk-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function () {});
}

/* On page load */
$(hkUpdateCartCount);

/* After adding — main ATC and bundle ATC */
$(document).on('click', '.hk-atc-js, a[href="#bundle_atc"]', function () {
  setTimeout(hkUpdateCartCount, 900);
});

/* After removing or changing quantity in the drawer */
$(document).on('click',
  'cart-drawer .cart-remove-button, cart-drawer [name="minus"], cart-drawer [name="plus"], cart-drawer a[href*="/cart/change"], .cart-remove-button',
  function () {
    setTimeout(hkUpdateCartCount, 900);
  }
);